import { useMutation } from '@tanstack/react-query';
import useGlynt from './useGlynt';
import { IRQCallbacks } from '../../types/my-types';

type ITrainingSetCertifyMutationParams = {
  trainingSetId: string;
};

export const useTrainingSetCertify = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();

  return useMutation({
    mutationFn: async (data: ITrainingSetCertifyMutationParams) => {
      return await (await glynt).trainingSet.certify(data.trainingSetId);
    },

    ...callbacks
  });
};
